import {
  alpha,
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  styled,
  Toolbar,
} from "@mui/material";
// import tradeGlobalBackground from "../Assets/TradeGlobalBackground1.jpg";
import logo from "../Assets/logo.png";
import InputBase from "@mui/material/InputBase";
import SideBar from "../SideBar/SideBar";
import { useLocation, useNavigate } from "react-router-dom";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: `${theme.shape.borderRadius * 2}px`,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  border: "1px solid lightgrey",
  padding: "0px",
  // height:"35PX",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  color: "lightgrey",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    color: "grey",
    fontSize: "15 px",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));
const buttonStyle = {
  fontSize: "0.75rem !important",
  minWidth: "40px",
  marginTop: "3px !important",
  opacity: 0.8,
  // background: "#dfd6f1ff",
  background: "white",
  color: "#7847dc",
  textTransform: "none",
  borderRadius: 10,
  paddingBottom: "3px !important",
  marginLeft: "8px",
  width: "70px",
  borderRadius: 10,
  paddingBottom: "3px",
  "&:hover": {
    backgroundColor: "#dfd6f1ff", // hover color
  },
};

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          position: "relative",
          background: "white",
          position: "fixed",
          top: 0,
          zIndex: 1000,
          // minHeight: "8vh",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* <div
              style={{
                display: "flex",
                height: "25px",
                width: "25px",
                alignItems: "center",
                justifyContent: "center", // Center horizontally
                backgroundImage: `url(${bgImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                margin: "10px",
              }}
            >
              <Box
                sx={{
                  color: "var(--Light-Theme-Background, #FFF)",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 600, // Changed to make the text bold, if desired
                  lineHeight: "16px",
                }}
              >
                D
              </Box>
            </div> */}
            <div>
              <SideBar />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div onClick={() => navigate("/")}>
                <img
                  src={logo}
                  style={{
                    height: "60px",
                    marginTop: "2px",
                    cursor: "pointer",
                  }}
                />
              </div>
              {location?.pathname?.includes("/detail-view") && (
                <div>
                  <Button
                    variant="contained"
                    onClick={() => {
                      navigate(-1);
                    }}
                    sx={{ ...buttonStyle, width: "auto" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M17.4995 9.99986C17.4995 10.1656 17.4337 10.3246 17.3165 10.4418C17.1992 10.559 17.0403 10.6249 16.8745 10.6249H4.63311L9.1917 15.1827C9.24977 15.2407 9.29583 15.3097 9.32726 15.3855C9.35869 15.4614 9.37486 15.5427 9.37486 15.6249C9.37486 15.707 9.35869 15.7883 9.32726 15.8642C9.29583 15.94 9.24977 16.009 9.1917 16.067C9.13363 16.1251 9.0647 16.1712 8.98883 16.2026C8.91295 16.234 8.83164 16.2502 8.74952 16.2502C8.66739 16.2502 8.58608 16.234 8.5102 16.2026C8.43433 16.1712 8.3654 16.1251 8.30733 16.067L2.68233 10.442C2.62422 10.384 2.57812 10.3151 2.54667 10.2392C2.51521 10.1633 2.49902 10.082 2.49902 9.99986C2.49902 9.91772 2.51521 9.8364 2.54667 9.76052C2.57812 9.68465 2.62422 9.61572 2.68233 9.55767L8.30733 3.93267C8.4246 3.8154 8.58366 3.74951 8.74952 3.74951C8.91537 3.74951 9.07443 3.8154 9.1917 3.93267C9.30898 4.04995 9.37486 4.20901 9.37486 4.37486C9.37486 4.54071 9.30898 4.69977 9.1917 4.81705L4.63311 9.37486H16.8745C17.0403 9.37486 17.1992 9.44071 17.3165 9.55792C17.4337 9.67513 17.4995 9.8341 17.4995 9.99986Z"
                        fill="#7847DC"
                      />
                    </svg>
                    &nbsp; Back to previous page
                  </Button>
                </div>
              )}
            </div>
            {/* <Box
              sx={{
                color: "var(--Light-Theme-Heading-Text, #151924)",
                fontFeatureSettings: " 'liga' off, 'clig' off",
                fontFamily: "Inter",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "32px",
              }}
            >
              Sourcing Compass
            </Box> */}
            {/* <IconButton>
              <img
                src={imgLogo}
                style={{
                  height: "40px",
                  // width: "20px",
                  // background:"white"
                  marginTop: "5px",
                  display: { xs: "none", md: "flex" },
                  mr: 1,
                }}
              />
            </IconButton> */}
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                width: "100%",
                height: "70%",
              }}
            >
              <div style={{ color: "black" }}>Home / Dashboard</div>
              <Box>
                <Search>
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  <StyledInputBase
                    placeholder="Type here..."
                    inputProps={{ "aria-label": "search" }}
                  />
                </Search>
              </Box>
              {true && (
                <div>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    // onClick={handleMenu}
                    color="inherit"
                  >
                    <AccountCircle sx={{ color: "blue" }} />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    // anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={false}
                    // onClose={handleClose}
                  >
                    <MenuItem>Profile</MenuItem>
                    <MenuItem>My account</MenuItem>
                  </Menu>
                </div>
              )} */}
            {/* <Box
                sx={{
                  minWidth: 250,
                  textAlign: "center",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #dcdcdc",
                  borderRadius: 5,
                }}
              > */}
            {/* <FormControl fullWidth sx={{height:"40px"}}> */}
            {/* <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    Select Material
                  </InputLabel> */}
            {/* <Select
                  fullWidth
                  value={selectedMaterial}
                  onChange={updateChange}
                  label="Select Material"
                  size="small"
                  sx={{
                    backgroundColor: "#ffffff",
                    borderRadius: 5,
                    border: "1px solid #dcdcdc",
                    textAlign: "center",
                  }}
                >
                  {Material.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select> */}
            {/* </FormControl> */}

            {/* </Box> */}
            {/* </Box> */}
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
}
export default Header;
